//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    data () {
        return {
            index: 0,
            questions: [
                {
                    questiontext: this.$lang.get('w4d3.game2.grades', {br: '\n'}),
                    answered: false,
                    answers: [
                        {
                            label: this.$lang.get('w4d3.game2.suited', {br: '\n'}),
                            clicked: false,
                            correct: false
                        },
                        {
                            label: this.$lang.get('w4d3.game2.next', {br: '\n'}),
                            clicked: false,
                            correct: true
                        }
                    ]
                },
                {
                    questiontext: this.$lang.get('w4d3.game2.math', {br: '\n'}),
                    answered: false,
                    answers: [
                        {
                            label: this.$lang.get('w4d3.game2.practice', {br: '\n'}),
                            clicked: false,
                            correct: true
                        },
                        {
                            label: this.$lang.get('w4d3.game2.talented', {br: '\n'}),
                            clicked: false,
                            correct: false
                        }
                    ]
                }
            ]
        };
    },

    computed: {
        result () {
            let numCorrect = this.questions.filter(question => question.answers.some(answer => answer.correct && answer.clicked)).length;
            let numTotalCorrect = this.questions.length;

            return this.$game.getMultipleChoiceResult(numCorrect, numTotalCorrect, 0);
        },
        showNext () {
            return !this.questions.some(question => !question.answered);
        }
    },

    methods: {
        setAnswer (question, answer) {
            question.answers.forEach(answer => answer.clicked = false);
            answer.clicked = true;
        }
    }
};
